<div class="flex-display fullComponent " *ngIf="showPage" role="main" aria-label="cross-reference">

  <div class="width-75 float-L view-height-overflow">
    <div class="pr-96px pt-3 pr-3" id="scrollToTop">
      <h1 class="pendingheading singleLine margin-0" [ngClass]="generateReport==true?'print-all-content':''" [innerHTML]="cr_header"></h1>

      <div class="mt-4 pt-1 flex-display">
        <label class="ml-8 para-content content-blue">{{cr_subtitle}}</label>
      </div>
      <div class="flex-display mb-24px info-box info-box-width my-1">
        <div><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
        <label class="ml-0-5 para-content content-blue">{{cr_info}}</label>
      </div>
      <!-- Search section -->
      <div class="mt-2 mb-1 flex-display">
        <div class="width-47" id="Standard" [ngClass]="radioStandard ?'search_area_highlight':''">
          <div class="mb-1 mt-1rem ml-0-5" >
            <mat-radio-button id="radio_standard" color="primary" class="contact-support-radio-button bold" value="Standard" [checked]="radioStandard"
              (change)="onSearchOptionChange('Standard')" (click)="CodificationForm.reset({})" (keyup.enter)="CodificationForm.reset({})" tabindex="0">{{cr_byStandard}}
            </mat-radio-button>
          </div>
          <form [formGroup]="StandardForm" class="ml-0-5 pt-0-7-5">
            <mat-form-field class="width-40 pb-1-5rem" appHostListenerClick>
              <mat-label>{{cr_standardType}}</mat-label>
              <mat-select formControlName="StandardType" #standardTypeDropdown (selectionChange)="onStandardTypeChange($event)" (keyup.enter)="setFocus($event)">
                <mat-option *ngFor="let type of standardtype_list" [value]="type">
                  {{type}}
                </mat-option>
              </mat-select>
            </mat-form-field>
           
            <mat-form-field class="width-27 ml-0-5 pb-1-5rem display_none_imp" [ngClass]="StandardForm.controls['StandardType'].value=='ASU'?'display_inline_block_imp':'display_none_imp'" appHostListenerClick>
              <mat-label>{{cr_year}}</mat-label>
              <mat-select formControlName="Year" #standardYearDropdown  [disabled]="standard_year_dropdown_disable"
                (selectionChange)="onStandardYearChange($event)" (keyup.enter)="setFocus($event)">
                <mat-option *ngFor="let year of standardtype_year_list" [value]="year">
                  {{year}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-27 ml-0-5 pb-1-5rem" appHostListenerClick>
              <mat-label>{{cr_number}}</mat-label>
              <mat-select formControlName="Number" #standardNumberDropdown (keyup.enter)="setFocus($event)" (selectionChange)="onStandardNumberChange()">
                <mat-option *ngFor="let number of standard_type_number_list" [value]="number">
                  {{number}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="width-47 ml-1" id="Codification" [ngClass]="radioCodification ?'search_area_highlight':''">
          <div class="mb-1 mt-1rem ml-0-5">
            <mat-radio-button color="primary" class="contact-support-radio-button bold" value="Codification" [checked]="radioCodification"
              (change)="onSearchOptionChange('Codification')" (click)="StandardForm.reset({})" (keyup.enter)="StandardForm.reset({})" tabindex="0">{{cr_byCodification}}
            </mat-radio-button>
          </div>
          <form [formGroup]="CodificationForm" class="ml-0-5 pt-0-7-5">
            <mat-form-field class="width-20 ml-0-5 pb-1-5rem">
              <mat-label>{{cr_topic}}</mat-label>
              <input matInput type="text" formControlName="Topic" [(ngModel)]="TopicValue" (change)="onCodificationInputChange($event)" (keyup.enter)="setFocus($event)">
            </mat-form-field>
            <mat-form-field class="width-25 ml-0-5 pb-1-5rem">
              <mat-label>{{cr_Subtopic}}</mat-label>
              <input matInput type="text" formControlName="Subtopic" [(ngModel)]="SubtopicValue"  (change)="onCodificationInputChange($event)" (keyup.enter)="setFocus($event)">
            </mat-form-field>
            <mat-form-field class="width-20 ml-0-5 pb-1-5rem">
              <mat-label>{{cr_section}}</mat-label>
              <input matInput type="text" formControlName="Section" [(ngModel)]="SectionValue"  (change)="onCodificationInputChange($event)" (keyup.enter)="setFocus($event)">
            </mat-form-field>
            <mat-form-field class="width-25 ml-0-5 pb-1-5rem">
              <mat-label>{{cr_paragraph}}</mat-label>
              <input matInput type="text" formControlName="Paragraph" [(ngModel)]="ParagraphValue"  (change)="onCodificationInputChange($event)" (keyup.enter)="setFocus($event)">
            </mat-form-field>
          </form>
        </div>
      </div>
      <div *ngIf="formvalidationError != ''">
        <mat-error class="mat-field-hint mb-1 mt-1" style="font-size: 1rem;"> {{formvalidationError}}</mat-error>
      </div>
      <!-- button section -->
      <div>

        <button mat-button
          [ngStyle]="{'border-color': (!(CodificationFormValid) && !(StandardForm.dirty))? '#8994A6': '#005CBF'}"
          class="btn-secondary-action-reset" type="reset"
          [disabled]="!(CodificationFormValid) && !(StandardForm.dirty)"
          (click)="StartOver(); generateReport=false;" (keyup.enter)="StartOver(); generateReport=false;" tabindex="0">{{cr_startOver}}</button>
        <button mat-button id="generateButton"
          [ngStyle]="{'background-color':   (!(CodificationFormValid) && !(StandardForm.dirty))? '#8994A6': '#005CBF'}"
          class="btn-primary-action-add" type="submit" [disabled]="!(CodificationFormValid) && !(StandardForm.dirty) && enableButton"
          (click)="GenerateCFReport(CodificationForm.value,StandardForm.value)" (keyup.enter)="GenerateCFReport(CodificationForm.value,StandardForm.value)" tabindex="0">{{cr_generate}}</button>
      </div>
      <!-- reoprts section -->
      <div *ngIf="generateReport" class="mb-24px">
        <div class="h-1" *ngIf="Standard_form_enable && DataSourceAvailable">{{cr_report_title}}
          {{StandardReport_title}}</div>
        <div class="h-1" *ngIf="Codification_form_enable && DataSourceAvailable">{{cr_report_title}}
          {{CodificationReport_title}}</div>

        <div *ngIf="DataSourceAvailable">
          <mat-accordion [multi]="true" class="mb-24px mt-40px" >
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header class="mataccordianHeader">
                <div class="matheadertext print-all-content"> {{cr_accordion1}}</div>
              </mat-expansion-panel-header>
              <div *ngIf="DataSourceAvailable" class="print-all-content">
                <app-cross-reference-table [table_Columns]="columnDetails" [Collection]="SearchSection" [table_data]="dataSource_standard_paragraph.data" [table_dataSource]="dataSource_standard_paragraph"
                  [table_sort_active]="SortActiveColumn" [is_cross_reference]="true"></app-cross-reference-table>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header class="mataccordianHeader">
                <div class="matheadertext print-all-content"> {{cr_accordion2}}</div>
              </mat-expansion-panel-header>
              <div *ngIf="DataSourceAvailable" class="print-all-content">
                <app-cross-reference-table [table_Columns]="columnDetails" [Collection]="SearchSection" [table_data]="dataSource_standard_glossaryTerms.data" [table_dataSource]="dataSource_standard_glossaryTerms"
                  [table_sort_active]="SortActiveColumn" [is_cross_reference]="true"></app-cross-reference-table>
              </div>
            </mat-expansion-panel>

          </mat-accordion>
        </div>
        <div id="topLoad" class="links cursor-pointer flex-display pl-12rem float-R text-decoration-none" (click)="gotoSection()" (keyup.enter)="gotoSection()" tabindex="0">
          <span class="pr-0-5rem mt-2 width-5-5rem font-14">Back to Top</span>
          <span>
            <img src="../../../assets/icons/ArrowUp-white.svg" class="selectedNavElement search_arrow_icon mt-1-5rem" alt="right up">
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="al-right float-R">
      <div class="padding-right-cf" (click)="openLinkById($event)" (keyup.enter)="openLinkById($event)" tabindex="0" [innerHTML]="cr_links" appHostListenerClick></div>
      <div class="content-width">
        <div class="qr_right">{{cr_quickReferenceSubtext}}</div>
    </div>
  </div>
</div>
